export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6404.e2f94e3f.jpg";